import React, { Component } from 'react'
import Slider from 'react-slick'
import { IonImg } from '@ionic/react'
import './homestyles1.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import { CarouselImageApi } from '../../request/api'
export default class CenterMode extends Component {
	constructor(props) {
		super(props)
		this.state = {
			imageArr: []
		}
	}

	componentDidMount() {
		CarouselImageApi().then(res => {
			if (res.code === 200) {
				if (res.data.length > 0) {
					const lang = localStorage.getItem('language-ind') || 'vie'
					let combList = []
					for (let item of res.data) {
						if (item.langValue === lang) {
							combList.push(item)
						}
					}
					if (combList.length > 0) {
						this.setState({ imageArr: combList })
					} else {
						this.setState({ imageArr: res.data })
					}
				}
			}
		})
	}

	render() {
		let { imageArr } = this.state
		const settings = {
			// className: 'center',
			// centerMode: true,
			infinite: true,
			slidesToShow: 1,
			// centerPadding: '60px',
			// dots: true,
			autoplay: true,
			speed: 1000,
			autoplaySpeed: 2500
		}
		return (
			<div className="slider-body">
				<Slider {...settings}>
					{imageArr.map((image, index) => {
						return (
							<div key={index} className="slider-item">
								{image.fileType !== 'video/mp4' ? <IonImg src={image.imgUrls} /> :
								<video loop autoPlay muted webkit-playsinline="true" x5-playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="false" style={{width: '100%', height: '200px', objectFit: 'fill', borderRadius: '15px'}}>
									<source src={image.imgUrls} type="video/mp4" />
								</video>}
							</div>
						)
					})}
				</Slider>
			</div>
		)
	}
}
